import React from "react";
import styled from "styled-components";
import TrackHeaderLoading from "../components/loadings/TrackHeaderLoading";
import RaceCardLoading from "../components/loadings/RaceCardLoading";
import BetSelectorLoading from "../components/loadings/BetSelectorLoading";
import { MainContainer } from "../components/Main/styled-components";
import { RunnerModifierEnum } from "../types";

interface ProgramPageLoadingProps {
  isMobile: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorTokens.background.base};
`;

const ProgramPageLoading = ({
  isMobile = false,
  ...props
}: ProgramPageLoadingProps) => (
  <Container data-qa-label="program-page-loading" {...props}>
    <TrackHeaderLoading isMobile={isMobile} />
    <BetSelectorLoading isMobile={isMobile} />
    <MainContainer>
      <RaceCardLoading
        isMobile={isMobile}
        runnerModifier={RunnerModifierEnum.DEFAULT}
      />
    </MainContainer>
  </Container>
);

export default ProgramPageLoading;
